// get largest val of varName field from Obj
export function myMax(obj, varName) {
  try {
    return obj.reduce((prev, curr) => prev[varName] < curr[varName] ? curr : prev)[varName]
  } catch {
    return 0
  }
}

// get small val of varName field from Obj
export function myMin(obj, varName) {
  try {
    return obj.reduce((prev, curr) => prev[varName] > curr[varName] ? curr : prev)[varName]
  } catch {
    return 0
  }
}

// get 'num' # of random ints b/n 'min' and 'max'
export function getRandomInts(min, max, num=1) {
  // make an array
  let ints = [];

  // for each 'num' fill the array with a random int b/n min and max
  for (let i=0; i<num; i++) {
    const _min = Math.ceil(min);
    const _max = Math.floor(max);
    const val = Math.floor(Math.random() * (_max - _min)) + _min; //The maximum is exclusive and the minimum is inclusive
    ints.push(val);
  }

  // if the arr has only 1 element, return that
  // if the arr has multiple elements, return the arr
  // else return empty arr
  let out = [];
  if (ints.length > 1) {
    out = ints;
  } else if (ints.length === 1) {
    out = ints[0]
  }
  return out
}
